/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from '@okta/okta-react';
import React, {useState, useEffect} from 'react';
import { Container, Icon, Image, Menu } from 'semantic-ui-react';
import { useHistory, useLocation } from "react-router-dom";
import {getAuthorizedFactoryFromAirtable} from './services/IO'

const Navbar = () => {
  const { authState, authService } = useOktaAuth();
  const history = useHistory();
  let location = useLocation();
  const [formTypes, setFormTypes] = useState(null)
  
  useEffect( () => {
    
    if (authState.isAuthenticated){
      authService.getUser().then( (info) => {
        if (info){
          (async () => {
            let factories = await getAuthorizedFactoryFromAirtable(info.email, authState.accessToken)
            
            if (factories && factories.formTypes && factories.formTypes.length && factories.formTypes.length > 0){
              setFormTypes(factories.formTypes)
            }
          })();

        }
        
      })
    }

    // return () => {
    //   console.log("This will be logged on unmount");
    // }

  }, [authState, authService]); // Update if authState changes

  const login = async () => authService.login('/form'); 
  const logout = async () => {
                                try {
                                  if (!authState.isAuthenticated) history.push('/')
                                  else authService.logout('/');
                                } catch (error) {
                                  console.error(error)
                                  history.push('/')
                                }
                              }

  const getIcon = (pathname) => {
    return (location.pathname === pathname ) ? 'check' : 'file'
  }

  const getIsActive = (pageType) =>{
    return (formTypes && formTypes.find(value => value === pageType))
  }

  return (
    <div>
      <Menu fixed="top" inverted>
        <Container>
          <Menu.Item as="a" header href="/">
            <Image size="mini" src="/chicon.png" /> 
            &nbsp;
            Cole Haan Costing
          </Menu.Item>
          {/* {authState.isAuthenticated && (
          <Menu.Item id="messages-button" as="a" href="/messages">
            <Icon name="mail outline" />
            Messages
          </Menu.Item>
          )} */}
          { (authState.isAuthenticated && getIsActive('Footwear')) && (
          <Menu.Item id="form-button" as="a" href="/form">
            <Icon name={getIcon('/form')} />
            Footwear Form
          </Menu.Item>
          )}
          {(authState.isAuthenticated && getIsActive('Accessories')) && (
          <Menu.Item id="accessories-button" as="a" href="/accessories">
            <Icon name={getIcon('/accessories')} />
            Accessories Form
          </Menu.Item>
          )}
          {/* {authState.isAuthenticated && <Menu.Item id="profile-button" as="a" href="/profile">Profile</Menu.Item>} */}
          {authState.isAuthenticated && <Menu.Item id="logout-button" as="a" onClick={logout}>Logout</Menu.Item>}
          {!authState.isPending && !authState.isAuthenticated && <Menu.Item as="a" onClick={login}>Login</Menu.Item>}
        </Container>
      </Menu>
    </div>
  );
};
export default Navbar;
